import './blogheaderv2.scss';
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function BlogHeaderV2() {
    return (
        <>
            <div className='Blog-Header-ContainerV2'>
                <div className='Blog-Header-Main-Top-BackGroundV2'>
                    <section className='Blog-Header-Main-Top-Text-ContainerV2'>
                        <h1>am<span>/</span>human</h1>
                        <div className='Blog-Header-Divider' />
                        <p className='Blog-header-Main-Text'>Bath & Body</p>
                        <p className='Blog-header-Main-Subtext'>Cold Process Soap &middot; Botanical Body Care</p>
                        <p className='Blog-header-Main-Subtext'>Thoughtful Forumulation for skin & Senses.</p>
                        <p className='Blog-header-Main-Subtext'>Made in Canada.</p>
                        <div className='Blog-Header-Main-Top-Text-LinksV2'>
                            <Link className="shop-link-main-page" to='/shop'>SHOP</Link>
                            <Link className="shop-recipe-main-page" to='/Recipes'>RECIPES</Link>
                        </div>
                    </section>
                    <div className='Blog-Header-Chevron'>
                        <i className="fa-solid fa-chevron-down"></i>
                    </div>
                </div>
            </div>
        </>
    )
}